import { SvgIconName } from '@shared/svg-icon/svg-icon-name';

export interface MenuItem {
  label: string;
  icon?: SvgIconName;
  action: Function;
  enabled: boolean;
  visible: boolean;
  shortcut?: string;
  appActionLogId?: string;
  id?: string
}

export const MENU_SEPARATOR = 'menuSeparator';

export type MenuList = (MenuItem | 'menuSeparator')[];

export interface MenuInterface {
  [label: string]: MenuHeader;
}

export type MenuHeader = {
  id: string,
  content: MenuList
}
